module.exports = {"name":"pages","version":"1.0.0","dependencies":{}}


//////////////////
// WEBPACK FOOTER
// ./src/pages/package.json
// module id = 1VA6
// module chunks = 1